import { render, staticRenderFns } from "./EmployeeCourses.vue?vue&type=template&id=b3bf6d52&scoped=true"
import script from "./EmployeeCourses.vue?vue&type=script&lang=js"
export * from "./EmployeeCourses.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCourses.vue?vue&type=style&index=0&id=b3bf6d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bf6d52",
  null
  
)

export default component.exports